let consulta = (proyectoJSON) => {

  //console.log(empresaJSON)

  const string =
    `mutation updateProyecto {
      updateProyecto(
        proyectoData: {
          id: "${proyectoJSON.id}",
          idEmpresa: "${proyectoJSON.idEmpresa}",
          nombre: "${proyectoJSON.nombre}",
          pais: "${proyectoJSON.pais}",
          direccion: "${proyectoJSON.direccion}",
          telefono: "${proyectoJSON.telefono}",
          correo: "${proyectoJSON.correo}",
          presupuesto: ${proyectoJSON.presupuesto},
          presupuestoGastado: ${proyectoJSON.presupuestoGastado},
          estado: "${proyectoJSON.estado}",
          fase: "${proyectoJSON.fase}",
          divisa: ${proyectoJSON.divisa}
        }
      )
      {
        mensaje
        id
      }
    }`

    return {
      "query": string
    }

}

export default consulta
